import directives from "./utils/directives";

export default {
  install: Vue => {
    for (let dir in directives) {
      if (directives.hasOwnProperty(dir)) {
        Vue.directive(dir, directives[dir])
      }
    }
  }
}
